import InviteUsers from '@/components/InviteUsers/index'
import PageWithBackButton from '@/components/PageWithBackButton/index'

export default {
  name: 'CreateGroup',
  components: {
    InviteUsers,
    PageWithBackButton
  }
}
